import array from '@mailobj-browser/front/js/utils/array.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import stopImmediatePropagation from '@mailobj-browser/front/js/events/hooks/stopImmediatePropagation.js'
import { modifiers } from '../../styles.js'
import * as anchor from '../../selectors/anchor.js'
import { tapUp } from '@mailobj-browser/front/js/events/listeners/builtins/tap.js'

const onTapUp = object(tapUp, {
  hooks: array([
    stopImmediatePropagation
  ]),
  task: (
    cell,
    event
  ) => {
    if (cell.classList.contains(modifiers.table_tbody_cell.listenable)) {
      const { parentNode } = cell
      const element = one(`a`, parentNode)
      const { target } = element

      if (target) {
        requestAnimationFrame(() => element.click())

        return
      }

      preventDefault(event)
      anchor.onTapUp.trigger(element)
    }
  }
})

export default (
  cell
) => {
  onTapUp.listen(cell)
}